export const LUMIQ_ORGANIZATION_NAME = 'LumiQ';
export const LUMIQ_INTERNAL_ORGANIZATION_NAME = 'LumiQ Internal';
